<template>
  <div class="node-status" v-if="nodeStatus">
    <span class="badge" :class="badgeClass" v-b-tooltip.hover :title="tooltipText">background processes</span>
  </div>
</template>

<script lang="ts">
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import { NodeStatusClient, NodeStatusDto } from '@/apiclient/apiclient_generated';
  import { WS_URL as ApiUrl } from '@/config';
  import axios from 'axios';

  @Component({})
  export default class NodeStatus extends Vue {
    private nodeStatus: NodeStatusDto | null = null;
    private nodeStatusClient = new NodeStatusClient(ApiUrl, axios);

    async mounted() {
      try {
        this.nodeStatus = await this.nodeStatusClient.get();
      } catch (e) {
        console.error('Failed to fetch node status', e);
      }
    }

    get badgeClass(): string {
      if (!this.nodeStatus) return '';
      if (this.nodeStatus.isLeader) return 'badge-success';
      if (this.nodeStatus.isAllowed) return 'badge-warning';
      return 'badge-danger';
    }

    get tooltipText(): string {
      if (!this.nodeStatus) return '';
      const node = this.nodeStatus.nodeId;
      if (this.nodeStatus.isLeader) return `${node}: Leader - running background tasks`;
      if (this.nodeStatus.isAllowed) return `${node}: Standby - ready to take over`;
      return `${node}: Not allowed to run background tasks`;
    }
  }
</script>
